import React, { useEffect } from "react";
import { fetchQuestions } from "assets/scripts/domain/auth/authActions";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
import useRedux from "assets/scripts/hooks/useRedux";
import { RegistrationBase } from "assets/scripts/components/containers/public/Registration/Registration";
import { registrationComplete } from "assets/scripts/domain/validation/validationActions";
import { RegistrationChannel } from "assets/scripts/domain/validation/validationModels";
export default function Registration(props) {
    const { confirmationRequirements, account, pin, email, relationship } = props;
    const [rState, dispatch] = useRedux(state => ({
        authQuestions: state.auth.questions,
        locale: state.i18n.locale,
        channel: state.validation.registrationChannel ?? RegistrationChannel.Unknown
    }));
    useEffect(() => {
        if (!rState.authQuestions) {
            dispatch(fetchQuestions());
        }
    }, []);
    if (!rState.authQuestions) {
        return (<div className={`wrapper ${process.env.FEATURE_PAYMENT_WIZARD ? "wrapper_narrowPlus" : "wrapper_medium"}`}>
				<StatusMessage isLoad isActive/>
			</div>);
    }
    return (<RegistrationBase authIndividuals={confirmationRequirements.authorized} deceased={confirmationRequirements.deceased} decedent={confirmationRequirements.decedent} locale={rState.locale} onSuccess={(a, p) => dispatch(registrationComplete(a, p))} pin={pin} emailAddress={email} referenceNumber={account.referenceNumber} securityQuestions={rState.authQuestions} validationQuestions={confirmationRequirements.confirmation} relationship={relationship} channel={rState.channel}/>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/QuickPay/Registration.tsx